<template>
  <div>
    <Drawer :title="resume_name + '-员工银行卡列表'" :closable="true" v-model="show" width="400">
      <div class="content">
        <div class="add_btn_title">
          可让员工关注微信公众号<span class="iconfont iconxiazai"></span><span class="gzh_span"
            @click="click_open_wxmp_show">《大湘员工服务中心》</span>自行添加银行卡更方便灵活！
        </div>
        <div class="add_btn">
          <Button type="" size="small" style="font-size: 13px;margin-right: 10px;" @click="bankcard_baobei_show = true">
            <Icon type="md-add" />异常银行卡报备
          </Button>
          <Button type="primary" size="small" style="font-size: 13px;" @click="click_add_card">
            <Icon type="md-add" />添加银行卡
          </Button>
        </div>
        <div class="cert_inner" v-for="(item, i) in bank_card_list" :key="i">
          <div class="default_tag" v-if="item.is_default == 1" @click="click_set_default(item)">
            默认工资卡
          </div>
          <div class="default_tag_set" @click="click_set_default(item)" v-else>
            设为默认
          </div>
          <div>
            <img class="bank_img" :src="item.bank_img" alt="" />
          </div>
          <div>
            <span class="cert_name">{{ item.bank_name }}</span>
            <span class="update_bank_id" @click="update_bank(item)">
              <Icon type="ios-repeat" />更新
            </span>
          </div>
          <div>
            <span class="cert_name2">银行卡ID：</span>
            <span class="cert_value">{{ item.card_id }}</span>
          </div>
          <!-- <div>
            <span class="cert_name2">银行编码：</span>
            <span class="cert_value">{{ item.bank_code }}</span>
          </div> -->
          <div>
            <span class="cert_name2">是否本人：</span>
            <span class="cert_value">{{ item.name }}</span>
            <span class="cert_value" v-if="item.is_self == 1">(本人卡)</span>
            <span class="cert_value" v-else>(非本人卡)</span>
          </div>
          <div>
            <span class="cert_name2">身份证号：</span>
            <span class="cert_value">{{ item.idcard }}</span>
          </div>
          <div>
            <span class="cert_name2">手机号码：</span>
            <span class="cert_value">{{ item.phone }}</span>
          </div>
          <div v-if="item.is_self != 1">
            <span class="cert_name2">委托文件：</span>
            <span class="cert_value3" @click="view_weituo_file(item)">点击查看</span>
          </div>
          <div>
            <span class="cert_name2">银行卡号：</span>
            <span class="cert_value2">{{ item.bank_card_number }}</span>
            <span class="copy_icon" @click="click_copy(item.bank_card_number)">
              <Icon size="18" type="md-copy" />
              <span class="copy_txt">复制</span>
            </span>
          </div>
          <div>
            <span class="cert_name2">检测银行：</span>

            <Tag color="success" :title="item.verify_bank_name" v-if="!item.consistent_name">一致</Tag>
            <Tag color="error" v-else>银行名不一致需留意,可点更新进行调整</Tag>

          </div>

          <div>
            <span class="cert_name2">提交时间：</span>
            <span class="cert_value">{{ item.create_time_fmt }}</span>
          </div>
          <div>
            <span class="cert_name2">操作：</span>
            <span class="cert_value_del" @click="del_card(item)">
              <Icon type="ios-trash-outline" />删除银行卡
            </span>
          </div>
        </div>
      </div>
    </Drawer>


    <Modal v-model="bankcard_baobei_show" :footer-hide="true" title="异常银行卡报备" :width="400">
      <div>
        发薪或添加银行卡出现的三要素异常银行卡，与员工核对后能正常收到款的可在此处报备。报备后正常操作即可。
      </div>
      <div class="bank_baobei_input_div">
        <div class="bank_baobei_input">
          <span>卡类型：</span>

        </div>
        <Select v-model="bankcard_baobei_item.card_type" style="width:200px">
          <Option value="yinhangka">银行卡</Option>
          <Option value="cunzhe">存折</Option>
        </Select>
        <div class="bank_baobei_input">
          <span>姓名：</span>
          <Input v-model="bankcard_baobei_item.name" placeholder="员工姓名" />
        </div>
        <div class="bank_baobei_input">
          <span>身份证号：</span>
          <Input v-model="bankcard_baobei_item.idcard" placeholder="身份证号码" />
        </div>
        <div class="bank_baobei_input">
          <span>银行卡号：</span>
          <Input v-model="bankcard_baobei_item.bankcard_number" placeholder="银行卡号" />
        </div>


      </div>
      <div style="display: flex;justify-content: end;margin-top:20px">
        <Button type="primary" @click="bankcard_baobei_ok">确认报备</Button>
      </div>
    </Modal>
    <Modal v-model="show_wxmp_qrcode" title="大湘员工服务中心 - 公众号二维码" width="440">
      <div>
        <img style="border-radius: 10px;overflow: auto;" src="@/assets/image/sys/daxiang_wxygfwzx.png" alt="">
      </div>
    </Modal>
    <Modal v-model="add_card_show" title="添加收款银行卡" :mask-closable="false" :footer-hide="true" width="500">
      <div style="height:300px;overflow: auto;">

        <div class="add_card_title">
          银行名称
        </div>
        <div>
          <Input disabled v-model="current_bank_item.name" placeholder="请输入银行卡号" style="width: 460px" />
        </div>
        <div class="add_card_title">
          银行卡类型：
        </div>
        <div>
          <RadioGroup v-model="add_card_item.is_self">
            <Radio label="1">
              <span>本人银行卡</span>
            </Radio>
            <Radio label="0">
              <span>非本人银行卡</span>
            </Radio>
          </RadioGroup>
        </div>
        <div v-if="add_card_item.is_self == 0">
          <div class="add_card_title">
            发薪委托书
          </div>
          <div>
            <div class="weituo_template" @click="click_template">
              <Icon type="ios-cloud-download-outline" />下载委托书模板
            </div>
            <div>
              <Upload :action="upload_url" :on-success="success_change">
                <Button icon="ios-cloud-upload-outline">上传委托书照片</Button>
              </Upload>
            </div>
          </div>
        </div>
        <Alert v-if="add_card_item.is_self == 0" type="warning">非本人银行卡，银行卡号与开卡人不要填本人信息，填写受托人信息</Alert>
        <div class="add_card_title">
          收款银行卡号
        </div>
        <div>
          <Input v-model="add_card_item.bank_number" placeholder="请输入银行卡号" style="width: 460px"
            @on-blur="bank_number_blur" />
        </div>
        <div class="add_card_title">
          开卡人真实姓名
        </div>
        <div>
          <Input v-model="add_card_item.name" placeholder="请输入持有人真实姓名" style="width: 460px" />
        </div>

        <div class="add_card_title">
          开卡人手机号码
        </div>
        <div>
          <Input v-model="add_card_item.phone" placeholder="请输入11位手机号" style="width: 460px" />
        </div>
        <div class="add_card_title">
          开卡人身份证号码
        </div>
        <div>
          <Input v-model="add_card_item.idcard" placeholder="请输入18位身份证号" style="width:460px" />
        </div>


      </div>
      <div class="add_card_btn">
        <Button type="primary" @click="add_new_bankcard">确认添加</Button>
      </div>
    </Modal>

    <Drawer title="银行列表" :closable="true" v-model="bank_show" width="500">
      <div>
        <Spin fix v-if="bank_loading">

        </Spin>
        <div style="margin-bottom:5px;">
          <Input search @on-search="get_bank_options" enter-button placeholder="搜索银行名称..." v-model="search_bank_name" />
        </div>
        <div class="bank_item_main">
          <div v-for="(item, i) in bank_list" :key="i" class="card_item" @click="click_bank(item)">
            <div class="bank_div">
              <div class="bank_logo">
                <img :src="item.logo" alt="" style="width:100%;" fit="cover">
              </div>
              <div class="bank_div_right">
                <div class="bank_name">
                  {{ item.name }}
                </div>
                <div>
                  <span class="name_small" v-for="(nameitem, nameindex) in item.name_list" :key="nameindex">
                    {{ nameitem }}<span v-if="nameindex < item.name_list.length - 1">、</span>
                  </span>

                </div>
              </div>

            </div>


          </div>
        </div>

      </div>

    </Drawer>

    <Drawer title="更新工资卡银行" :closable="true" v-model="update_bank_show" width="500">
      <div>
        <Spin fix v-if="bank_loading">

        </Spin>
        <div style="margin-bottom:5px;">
          <Input search @on-search="get_bank_options" enter-button placeholder="搜索银行名称..." v-model="search_bank_name" />
        </div>
        <div class="bank_item_main">
          <div v-for="(item, i) in bank_list" :key="i" class="card_item" @click="click_bank_update(item)">
            <div class="bank_div">
              <div class="bank_logo">
                <img :src="item.logo" alt="" style="width:100%;" fit="cover">
              </div>
              <div class="bank_div_right">
                <div class="bank_name">
                  {{ item.name }}
                </div>
                <div>
                  <span class="name_small" v-for="(nameitem, nameindex) in item.name_list" :key="nameindex">
                    {{ nameitem }}<span v-if="nameindex < item.name_list.length - 1">、</span>
                  </span>

                </div>
              </div>

            </div>


          </div>
        </div>

      </div>

    </Drawer>


  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "staff_bankcard",
  data() {
    return {
      show: false,
      resume_id: "",
      bank_card_list: [],
      resume_name: '',
      add_card_show: false,
      add_card_item: {
        is_self: -1,
        bank_number: "",
        name: '',
        phone: '',
        idcard: '',
        weituo_file: '',
        weituo_file_url: ''
      },
      upload_url:
        process.env.VUE_APP_HOST +
        "/roster_manage/payment_weituoshu/upload_weituoshu?token=" +
        this.$cookies.get("dx_token"),

      bank_show: false,
      search_bank_name: '',
      bank_list: [],
      current_bank_item: {},
      bank_loading: false,
      show_wxmp_qrcode: false,
      update_bank_item: {},
      update_bank_show: false,

      bankcard_baobei_show: false,
      bankcard_baobei_item: {
        name: "",
        idcard: "",
        bankcard_number: '',
        card_type: 'yinhangka'

      },
      project_id: ''
    };
  },
  methods: {

    del_card(item) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>正在删除这张银行卡，是否继续？</p>',
        onOk: () => {
          this.del_card_request(item.card_id, item.resume_id)
        },
        onCancel: () => {

        }
      });
    },


    del_card_request(card_id, resume_id) {
      var that = this;
      var _dict = {
        card_id: card_id,
        resume_id: resume_id
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/bankcard/resume_bankcard_del",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.open(resume_id)

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },


    bank_number_blur(e) {
      var str1 = add_card_item.bank_number;

    },

    click_open_wxmp_show() {
      this.show_wxmp_qrcode = true
    },

    get_bank_options() {
      var that = this;
      var _dict = {
        search_name: this.search_bank_name
      };
      that.bank_loading = true
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/bankcard/resume_bankcard_all",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.bank_list = res.data.data_list
            // that.$Message.success({
            //   content: res.msg,
            //   duration: 3,
            // });
            that.bank_loading = false
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
            that.bank_loading = false
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    add_new_bankcard() {
      var that = this;
      var _dict = {
        is_self: this.add_card_item.is_self,
        weituo_file: this.add_card_item.weituo_file,
        bank_id: this.add_card_item.bank_id,
        bank_card_number: this.add_card_item.bank_number,
        name: this.add_card_item.name,
        phone: this.add_card_item.phone,
        idcard: this.add_card_item.idcard,
        resume_id: this.resume_id,
        bank_id: this.current_bank_item.bank_id,

      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/bankcard/resume_bankcard_add",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_card_show = false
            that.bank_show = false
            that.open(that.resume_id)

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    success_change(e) {
      console.log(e);
      if (e.code == 0) {
        this.add_card_item.weituo_file = e.data.object_name;
        this.add_card_item.weituo_file_url = e.data.url;
        this.$Message.success(e.msg);
      } else {
        this.$Message.error(e.msg);
      }
    },

    click_add_card() {
      // this.add_card_show = true
      this.get_bank_options()
      this.bank_show = true
    },
    click_view(item) { },

    click_bank(item) {
      this.current_bank_item = item
      this.add_card_show = true
    },

    click_copy(e) {
      this.$Copy({
        text: e
      });
    },

    click_set_default(item) {
      var that = this;
      var _dict = {
        card_id: item.card_id,
        resume_id: item.resume_id
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/bankcard/resume_bankcard_default_set",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.open(item.resume_id)

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    bankcard_baobei_ok() {
      var that = this;
      var obj = {
        name: this.bankcard_baobei_item.name,
        idcard: this.bankcard_baobei_item.idcard,
        bankcard_number: this.bankcard_baobei_item.bankcard_number,
        card_type: this.bankcard_baobei_item.card_type,
        project_id: this.project_id,

      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/error_bankcard_baobei",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    open(resume_id,) {


      this.resume_id = resume_id
      this.show = true;
      var that = this;
      var _dict = {
        resume_id: resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/bankcard/resume_bankcard_list",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            // that.$Message.success({
            //   content: res.msg,
            //   duration: 3,
            // });
            that.bank_card_list = res.data.bank_card_list;
            that.resume_name = res.data.resume_name
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    view_weituo_file(item) {
      open_new_page(item.weituo_url)
    },

    click_template() {
      open_new_page(
        "https://static.daxiangsys.com/dx-short-link/xls/薪资委托收款书.docx"
      );
    },

    update_bank(item) {
      this.update_bank_item = item
      this.update_bank_show = true
      this.get_bank_options()
    },
    click_bank_update(item) {
      var that = this;
      var _dict = {
        card_id: this.update_bank_item.card_id,
        bank_id: item.bank_id,
        resume_id: this.update_bank_item.resume_id
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/bankcard/resume_bankcard_update",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_bank_show = false
            that.open(that.update_bank_item.resume_id)

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    }
  },
};
</script>

<style scoped>
.bank_baobei_input_div {
  margin-top: 10px;
}

.bank_baobei_input {
  margin-top: 10px;
}


.update_bank_id {
  cursor: pointer;
  color: #0466dd;
  font-size: 13px;
  margin-left: 10px;
}

.iconxiazai {
  color: #459f19;
}

.gzh_span:hover {
  font-weight: 600;
}

.gzh_span {
  cursor: pointer;
  color: #0466dd;
}

.add_btn_title {
  font-size: 13px;
  ;
}

.add_card_list {
  display: flex;
}

.name_small {
  font-size: 12px;
  color: #ccc;
}

.bank_name {
  font-weight: 400;
}

.bank_div_right {
  width: 100%;
  text-align: left;
  margin-left: 10px;
}

.bank_item_main {
  height: calc(100vh - 130px);
  overflow: auto;
}

.bank_logo {
  width: 40px;
  height: 40px;
  overflow: hidden;
}

.bank_div {
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.card_item {
  border-bottom: 1px solid #e9e9e9;
  padding: 0 0 0 10px;

}

.card_item:hover {
  cursor: pointer;
  background-color: #f1f1f1;
}

.weituo_template {
  cursor: pointer;
  align-items: center;
  display: flex;
  justify-content: end;
  color: #0466dd;
  font-weight: 400;
}

.add_card_btn {
  display: flex;
  justify-content: end;
  margin-top: 10px;
}

.add_card_title {
  margin-bottom: 5px;
  margin-top: 10px;
  font-weight: 600;
  width: 250px;
  ;
}

.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.bank_img {
  opacity: 0.1;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  position: absolute;
  right: 10px;
  top: 30px;
}

.add_btn {
  display: flex;
  justify-content: end;
  margin-bottom: 10px;
  border-bottom: 1px dashed #e3e3e3;
  padding-bottom: 10px;
}

.cert_value_del {
  font-size: 13px;
  color: red
}

.cert_value {
  font-size: 13px;
}

.cert_value3 {
  font-size: 13px;
  cursor: pointer;
  color: #0466dd;
}

.cert_value2 {
  font-size: 13px;
  font-weight: 600;
  color: #000;

}

.default_tag_set {
  position: absolute;
  right: 0px;
  color: #848484;
  font-size: 13px;
  background-color: rgb(240, 240, 240);
  padding: 2px 10px;
  border-radius: 0 5px 0 10px;
  top: 0;
}

.default_tag {
  position: absolute;
  right: 0px;
  color: #fff;
  font-size: 13px;
  background-color: red;
  padding: 2px 10px;
  border-radius: 0 5px 0 10px;
  top: 0;
}

.cert_name {
  font-weight: 600;
  color: #000;

}

.cert_name2 {
  font-size: 13px;
}

.content {
  padding: 0 10px 10px 10px;

}

.copy_icon {
  margin-left: 5px;
  color: rgb(48, 120, 230);
  cursor: pointer;
}

.copy_txt {
  font-size: 13px;
}

.cert_inner {
  border: 1px solid #ececec;
  border-radius: 5px;
  box-shadow: 0 0 3px #ededed;
  padding: 10px 15px;
  width: 350px;
  margin: 0 10px 10px 0;
  cursor: pointer;
  position: relative;
}

/* .cert_inner:hover {
  background: #30445d;
  color: #fff;
} */
</style>
